// src/data/mosTranslations.js
// Civilian translation layer for military occupation codes
// Maps occupation codes to civilian job titles, skills, and industries

export const translations = {

  // ══════════════════════════════════════════════════════════════════
  // ARMY — ENLISTED
  // ══════════════════════════════════════════════════════════════════

  '11B': {
    civilianTitles: ['Security Manager', 'Law Enforcement Officer', 'Emergency Management Specialist', 'Corporate Security Director', 'Corrections Officer'],
    skills: ['Small unit leadership', 'Risk assessment', 'Crisis response', 'Physical security', 'Team coordination', 'Land navigation', 'Weapons safety'],
    industries: ['Law Enforcement', 'Private Security', 'Emergency Management', 'Federal Agencies', 'Corrections'],
  },
  '11C': {
    civilianTitles: ['Ballistics Technician', 'Weapons Systems Specialist', 'EOD Technician', 'Security Specialist', 'Range Safety Officer'],
    skills: ['Indirect fire systems', 'Precision targeting', 'Logistics coordination', 'Safety protocols', 'Team leadership'],
    industries: ['Defense Contracting', 'Law Enforcement', 'Federal Agencies', 'Security'],
  },
  '12B': {
    civilianTitles: ['Construction Project Manager', 'Civil Engineer', 'Safety Manager', 'Demolition Specialist', 'Infrastructure Consultant'],
    skills: ['Construction management', 'Explosive safety', 'Site assessment', 'Project planning', 'Heavy equipment operation'],
    industries: ['Construction', 'Engineering', 'Mining', 'Infrastructure', 'Defense Contracting'],
  },
  '17C': {
    civilianTitles: ['Cybersecurity Analyst', 'Penetration Tester', 'Network Security Engineer', 'Threat Intelligence Analyst', 'Red Team Operator'],
    skills: ['Offensive cyber operations', 'Network exploitation', 'Vulnerability assessment', 'Digital forensics', 'Threat analysis'],
    industries: ['Cybersecurity', 'Defense Contracting', 'Federal Agencies', 'Financial Services', 'Technology'],
  },
  '25B': {
    civilianTitles: ['IT Systems Administrator', 'Network Administrator', 'Help Desk Manager', 'Cloud Infrastructure Specialist', 'IT Support Engineer'],
    skills: ['Network administration', 'Systems troubleshooting', 'User support', 'Server management', 'IT security basics'],
    industries: ['Information Technology', 'Healthcare IT', 'Financial Services', 'Federal Agencies', 'Telecommunications'],
  },
  '25D': {
    civilianTitles: ['Cybersecurity Analyst', 'Network Defender', 'SOC Analyst', 'Information Systems Security Officer (ISSO)', 'Incident Response Analyst'],
    skills: ['Network defense', 'Intrusion detection', 'SIEM tools', 'Incident response', 'Security monitoring', 'Vulnerability scanning'],
    industries: ['Cybersecurity', 'Defense Contracting', 'Federal Agencies', 'Financial Services', 'Healthcare IT'],
  },
  '31B': {
    civilianTitles: ['Police Officer', 'Security Manager', 'Loss Prevention Specialist', 'Corporate Investigator', 'Federal Law Enforcement Officer'],
    skills: ['Law enforcement procedures', 'Criminal investigations', 'De-escalation', 'Report writing', 'Community relations'],
    industries: ['Law Enforcement', 'Private Security', 'Federal Agencies', 'Corrections', 'Corporate Security'],
  },
  '31D': {
    civilianTitles: ['Criminal Investigator', 'Special Agent', 'Corporate Investigator', 'Fraud Analyst', 'Compliance Investigator'],
    skills: ['Criminal investigations', 'Interviewing techniques', 'Evidence collection', 'Report writing', 'Surveillance'],
    industries: ['Federal Law Enforcement', 'Insurance', 'Financial Services', 'Corporate Security', 'Legal'],
  },
  '35F': {
    civilianTitles: ['Intelligence Analyst', 'Threat Intelligence Analyst', 'Risk Analyst', 'Data Analyst', 'Research Analyst'],
    skills: ['Intelligence analysis', 'Data synthesis', 'Report writing', 'Pattern recognition', 'Open source intelligence (OSINT)'],
    industries: ['Defense Contracting', 'Federal Agencies', 'Financial Services', 'Cybersecurity', 'Consulting'],
  },
  '35L': {
    civilianTitles: ['Counterintelligence Analyst', 'Corporate Security Investigator', 'Insider Threat Analyst', 'Special Agent', 'Risk Consultant'],
    skills: ['Counterintelligence operations', 'Behavioral analysis', 'Interviewing', 'Report writing', 'Threat assessment'],
    industries: ['Federal Agencies', 'Defense Contracting', 'Corporate Security', 'Consulting', 'Financial Services'],
  },
  '35M': {
    civilianTitles: ['Human Intelligence Officer', 'Research Analyst', 'Corporate Investigator', 'International Relations Specialist', 'Policy Analyst'],
    skills: ['Source development', 'Interviewing and elicitation', 'Cultural awareness', 'Report writing', 'Foreign language skills'],
    industries: ['Federal Agencies', 'Defense Contracting', 'Consulting', 'Nonprofit', 'International Organizations'],
  },
  '35N': {
    civilianTitles: ['Signals Intelligence Analyst', 'Electronic Warfare Analyst', 'Communications Security Specialist', 'RF Engineer', 'Cybersecurity Analyst'],
    skills: ['Signals collection', 'Electronic analysis', 'Communications systems', 'Data interpretation', 'Technical reporting'],
    industries: ['Defense Contracting', 'Federal Agencies', 'Telecommunications', 'Cybersecurity', 'Technology'],
  },
  '35P': {
    civilianTitles: ['Linguist', 'Translator', 'Intelligence Analyst', 'Foreign Language Instructor', 'International Relations Specialist'],
    skills: ['Foreign language proficiency', 'Translation and interpretation', 'Cultural analysis', 'Intelligence reporting', 'Document exploitation'],
    industries: ['Federal Agencies', 'Defense Contracting', 'Education', 'International Organizations', 'Consulting'],
  },
  '37F': {
    civilianTitles: ['Communications Specialist', 'Public Affairs Officer', 'Marketing Manager', 'Media Relations Specialist', 'Behavioral Analyst'],
    skills: ['Strategic communications', 'Media production', 'Behavioral influence', 'Cross-cultural communication', 'Campaign planning'],
    industries: ['Marketing', 'Public Relations', 'Federal Agencies', 'Nonprofit', 'Consulting'],
  },
  '42A': {
    civilianTitles: ['Human Resources Specialist', 'HR Manager', 'Talent Acquisition Specialist', 'Benefits Administrator', 'People Operations Manager'],
    skills: ['Personnel management', 'Benefits administration', 'Records management', 'Employee relations', 'Onboarding'],
    industries: ['Human Resources', 'Healthcare', 'Corporate', 'Federal Agencies', 'Education'],
  },
  '68W': {
    civilianTitles: ['Emergency Medical Technician (EMT)', 'Paramedic', 'Physician Assistant', 'Surgical Technologist', 'Healthcare Administrator'],
    skills: ['Emergency medical care', 'Trauma response', 'Patient assessment', 'Triage', 'IV therapy', 'Medical documentation'],
    industries: ['Healthcare', 'Emergency Services', 'Fire Departments', 'Hospitals', 'Pharmaceuticals'],
  },
  '68X': {
    civilianTitles: ['Mental Health Counselor', 'Social Worker', 'Case Manager', 'Substance Abuse Counselor', 'Psychiatric Technician'],
    skills: ['Mental health assessment', 'Crisis intervention', 'Case management', 'Counseling techniques', 'Documentation'],
    industries: ['Healthcare', 'Nonprofit', 'Veterans Services', 'Social Services', 'Education'],
  },
  '74D': {
    civilianTitles: ['Hazmat Specialist', 'Environmental Health and Safety Manager', 'Emergency Preparedness Coordinator', 'CBRN Consultant', 'Safety Officer'],
    skills: ['Hazardous materials handling', 'Decontamination procedures', 'Emergency response planning', 'Risk assessment', 'Regulatory compliance'],
    industries: ['Environmental Services', 'Emergency Management', 'Manufacturing', 'Federal Agencies', 'Healthcare'],
  },
  '88M': {
    civilianTitles: ['Truck Driver (CDL)', 'Logistics Coordinator', 'Fleet Manager', 'Transportation Supervisor', 'Supply Chain Specialist'],
    skills: ['Commercial vehicle operation', 'Route planning', 'Load management', 'Safety compliance', 'Fleet coordination'],
    industries: ['Transportation', 'Logistics', 'Supply Chain', 'Construction', 'Federal Agencies'],
  },
  '89B': {
    civilianTitles: ['Ammunition Technician', 'Explosives Specialist', 'EOD Technician', 'Range Safety Officer', 'Hazmat Specialist'],
    skills: ['Explosives handling', 'Safety protocols', 'Inventory management', 'Demolition', 'Risk assessment'],
    industries: ['Defense Contracting', 'Mining', 'Federal Agencies', 'Law Enforcement', 'Construction'],
  },
  '89D': {
    civilianTitles: ['EOD Technician', 'Bomb Squad Officer', 'Explosives Detection Specialist', 'Hazmat Technician', 'Federal Agent'],
    skills: ['Explosive ordnance disposal', 'Robot operations', 'Risk assessment', 'Technical reporting', 'Crisis response'],
    industries: ['Law Enforcement', 'Federal Agencies', 'Defense Contracting', 'Aviation Security', 'Private Security'],
  },
  '91B': {
    civilianTitles: ['Diesel Mechanic', 'Fleet Maintenance Manager', 'Automotive Technician', 'Equipment Operator', 'Service Manager'],
    skills: ['Vehicle maintenance', 'Diagnostics', 'Preventive maintenance', 'Parts management', 'Technical documentation'],
    industries: ['Automotive', 'Transportation', 'Construction', 'Mining', 'Fleet Services'],
  },
  '92A': {
    civilianTitles: ['Logistics Coordinator', 'Supply Chain Analyst', 'Inventory Manager', 'Warehouse Manager', 'Procurement Specialist'],
    skills: ['Inventory control', 'Supply chain management', 'ERP systems', 'Logistics planning', 'Warehouse operations'],
    industries: ['Logistics', 'Supply Chain', 'Retail', 'Manufacturing', 'Federal Agencies'],
  },
  '92F': {
    civilianTitles: ['Petroleum Engineer Technician', 'Fuel Operations Manager', 'Pipeline Technician', 'Logistics Coordinator', 'Safety Compliance Officer'],
    skills: ['Fuel handling', 'Pipeline operations', 'Safety compliance', 'Inventory management', 'Equipment maintenance'],
    industries: ['Oil and Gas', 'Aviation', 'Transportation', 'Federal Agencies', 'Logistics'],
  },
  '92G': {
    civilianTitles: ['Executive Chef', 'Food Service Manager', 'Restaurant Manager', 'Catering Director', 'Nutritionist'],
    skills: ['Large-scale food production', 'Menu planning', 'Food safety compliance', 'Team leadership', 'Inventory management'],
    industries: ['Food Service', 'Hospitality', 'Healthcare', 'Education', 'Corporate Dining'],
  },

  // ══════════════════════════════════════════════════════════════════
  // ARMY — OFFICER
  // ══════════════════════════════════════════════════════════════════

  '11A': {
    civilianTitles: ['Operations Director', 'Program Manager', 'Security Consultant', 'Corporate Executive', 'Federal Agency Director'],
    skills: ['Large-scale operations management', 'Strategic planning', 'Personnel leadership (100–1000+)', 'Budget management', 'Crisis decision-making', 'Cross-functional coordination'],
    industries: ['Defense Contracting', 'Consulting', 'Corporate Leadership', 'Federal Agencies', 'Private Security'],
  },
  '12A': {
    civilianTitles: ['Civil Engineer', 'Construction Project Executive', 'Infrastructure Program Manager', 'Engineering Director', 'Project Controls Manager'],
    skills: ['Large-scale project management', 'Engineering oversight', 'Budget and resource management', 'Contract management', 'Team leadership'],
    industries: ['Construction', 'Engineering', 'Infrastructure', 'Defense Contracting', 'Federal Agencies'],
  },
  '17A': {
    civilianTitles: ['Chief Information Security Officer (CISO)', 'Cyber Operations Director', 'Red Team Lead', 'Cybersecurity Program Manager', 'VP of Security'],
    skills: ['Cyber warfare strategy', 'Offensive and defensive cyber operations', 'Team leadership', 'Budget management', 'Policy development', 'Risk management'],
    industries: ['Cybersecurity', 'Defense Contracting', 'Financial Services', 'Technology', 'Federal Agencies'],
  },
  '17B': {
    civilianTitles: ['Cyber Operations Manager', 'Penetration Testing Lead', 'Threat Intelligence Manager', 'SOC Director', 'Information Security Manager'],
    skills: ['Cyber operations planning', 'Vulnerability management', 'Incident command', 'Team leadership', 'Stakeholder reporting'],
    industries: ['Cybersecurity', 'Defense Contracting', 'Technology', 'Federal Agencies', 'Financial Services'],
  },
  '18A': {
    civilianTitles: ['Special Operations Consultant', 'Security Program Director', 'Crisis Management Executive', 'Federal Senior Agent', 'Risk Management Director'],
    skills: ['Unconventional warfare', 'Foreign internal defense', 'Strategic planning', 'Multi-cultural leadership', 'Interagency coordination'],
    industries: ['Defense Contracting', 'Federal Agencies', 'Consulting', 'Private Security', 'International Organizations'],
  },
  '25A': {
    civilianTitles: ['Chief Technology Officer (CTO)', 'IT Director', 'Network Engineering Director', 'Telecommunications Executive', 'IT Program Manager'],
    skills: ['IT strategy', 'Network architecture', 'Cybersecurity oversight', 'Vendor management', 'Budget management', 'Team leadership'],
    industries: ['Information Technology', 'Telecommunications', 'Defense Contracting', 'Federal Agencies', 'Financial Services'],
  },
  '27A': {
    civilianTitles: ['Attorney', 'Corporate Counsel', 'Compliance Officer', 'Legal Advisor', 'Government Affairs Director'],
    skills: ['Legal analysis', 'Contract law', 'Litigation', 'Regulatory compliance', 'Negotiation', 'Policy interpretation'],
    industries: ['Legal', 'Corporate Counsel', 'Federal Agencies', 'Defense Contracting', 'Financial Services'],
  },
  '31A': {
    civilianTitles: ['Police Chief', 'Security Director', 'Federal Law Enforcement Supervisor', 'Loss Prevention Executive', 'Risk Management Director'],
    skills: ['Law enforcement leadership', 'Criminal investigations oversight', 'Policy development', 'Community relations', 'Emergency management'],
    industries: ['Law Enforcement', 'Federal Agencies', 'Corporate Security', 'Private Security', 'Consulting'],
  },
  '35D': {
    civilianTitles: ['Intelligence Director', 'Threat Intelligence Program Manager', 'Risk Analysis Executive', 'Senior Intelligence Advisor', 'Research Director'],
    skills: ['All-source intelligence production', 'Strategic analysis', 'Intelligence program management', 'Interagency coordination', 'Executive briefing'],
    industries: ['Defense Contracting', 'Federal Agencies', 'Financial Services', 'Consulting', 'Technology'],
  },
  '36A': {
    civilianTitles: ['Financial Director', 'Controller', 'Budget Director', 'Finance Program Manager', 'CFO'],
    skills: ['Financial management', 'Budget oversight', 'Accounting systems', 'Audit compliance', 'Financial reporting', 'Team leadership'],
    industries: ['Finance', 'Federal Agencies', 'Defense Contracting', 'Corporate Finance', 'Consulting'],
  },
  '38A': {
    civilianTitles: ['International Development Specialist', 'Government Affairs Director', 'Policy Analyst', 'NGO Program Director', 'Foreign Affairs Officer'],
    skills: ['Civil-military operations', 'Interagency coordination', 'Community engagement', 'Foreign culture expertise', 'Project management'],
    industries: ['International Development', 'Nonprofit', 'Federal Agencies', 'Consulting', 'State Department'],
  },
  '42B': {
    civilianTitles: ['Chief Human Resources Officer (CHRO)', 'HR Director', 'Talent Management Executive', 'Organizational Development Director', 'People Operations VP'],
    skills: ['HR strategy', 'Talent acquisition', 'Organizational development', 'Policy development', 'Employee relations', 'Leadership development'],
    industries: ['Human Resources', 'Corporate', 'Healthcare', 'Federal Agencies', 'Consulting'],
  },
  '90A': {
    civilianTitles: ['Supply Chain Director', 'Logistics Executive', 'Operations Director', 'Distribution Center Director', 'VP of Operations'],
    skills: ['Supply chain strategy', 'Logistics management', 'Budget oversight', 'Vendor management', 'Process improvement', 'Team leadership'],
    industries: ['Logistics', 'Manufacturing', 'Retail', 'Defense Contracting', 'Federal Agencies'],
  },

  // ══════════════════════════════════════════════════════════════════
  // MARINE CORPS — ENLISTED
  // ══════════════════════════════════════════════════════════════════

  '0311': {
    civilianTitles: ['Security Manager', 'Law Enforcement Officer', 'Emergency Response Specialist', 'Corporate Security Director', 'Federal Agent'],
    skills: ['Small unit tactics', 'Leadership under pressure', 'Physical security', 'Team coordination', 'Risk management'],
    industries: ['Law Enforcement', 'Private Security', 'Federal Agencies', 'Emergency Management', 'Corrections'],
  },
  '0321': {
    civilianTitles: ['Special Operations Consultant', 'Intelligence Analyst', 'Security Consultant', 'Federal Agent', 'Risk Assessment Specialist'],
    skills: ['Reconnaissance operations', 'Intelligence collection', 'Stealth operations', 'Leadership', 'Mission planning'],
    industries: ['Defense Contracting', 'Federal Agencies', 'Private Security', 'Consulting', 'Intelligence'],
  },
  '0651': {
    civilianTitles: ['Cybersecurity Analyst', 'Network Administrator', 'Systems Administrator', 'IT Security Specialist', 'SOC Analyst'],
    skills: ['Network security', 'Cyber operations', 'Systems administration', 'Threat detection', 'Security monitoring'],
    industries: ['Cybersecurity', 'Defense Contracting', 'Federal Agencies', 'Technology', 'Financial Services'],
  },
  '5811': {
    civilianTitles: ['Police Officer', 'Security Manager', 'Loss Prevention Specialist', 'Federal Law Enforcement Officer', 'Corrections Officer'],
    skills: ['Law enforcement', 'Investigations', 'Report writing', 'De-escalation', 'Community policing'],
    industries: ['Law Enforcement', 'Private Security', 'Federal Agencies', 'Corrections', 'Corporate Security'],
  },
  '6174': {
    civilianTitles: ['Aviation Mechanic', 'Aircraft Maintenance Technician', 'FAA Inspector', 'Aerospace Technician', 'Flight Operations Manager'],
    skills: ['Helicopter maintenance', 'Avionics systems', 'Safety inspections', 'Technical documentation', 'Troubleshooting'],
    industries: ['Aviation', 'Aerospace', 'Defense Contracting', 'Airlines', 'Federal Agencies'],
  },

  // ══════════════════════════════════════════════════════════════════
  // MARINE CORPS — OFFICER
  // ══════════════════════════════════════════════════════════════════

  '0302': {
    civilianTitles: ['Operations Director', 'Program Manager', 'Security Consultant', 'Corporate Executive', 'Crisis Management Director'],
    skills: ['Infantry operations leadership', 'Strategic planning', 'Personnel management (200–3000)', 'Budget oversight', 'Crisis decision-making'],
    industries: ['Defense Contracting', 'Consulting', 'Corporate Leadership', 'Federal Agencies', 'Private Security'],
  },
  '0602': {
    civilianTitles: ['IT Director', 'Network Engineering Manager', 'Telecommunications Director', 'Cybersecurity Program Manager', 'CTO'],
    skills: ['Communications systems leadership', 'Network architecture oversight', 'Cybersecurity strategy', 'Budget management', 'Team leadership'],
    industries: ['Information Technology', 'Telecommunications', 'Defense Contracting', 'Federal Agencies', 'Financial Services'],
  },
  '0802': {
    civilianTitles: ['Operations Director', 'Program Manager', 'Defense Contractor Executive', 'Logistics Director', 'Weapons Systems Program Manager'],
    skills: ['Fire support coordination', 'Strategic planning', 'Joint operations', 'Budget management', 'Cross-functional leadership'],
    industries: ['Defense Contracting', 'Federal Agencies', 'Consulting', 'Aerospace', 'Corporate Leadership'],
  },
  '1302': {
    civilianTitles: ['Construction Executive', 'Civil Engineering Director', 'Infrastructure Program Manager', 'Project Controls Director', 'Facilities Manager'],
    skills: ['Engineering program management', 'Construction oversight', 'Budget and contract management', 'Safety leadership', 'Team leadership'],
    industries: ['Construction', 'Engineering', 'Infrastructure', 'Defense Contracting', 'Federal Agencies'],
  },
  '1702': {
    civilianTitles: ['Cybersecurity Director', 'CISO', 'Cyber Operations Program Manager', 'Information Security Executive', 'Red Team Director'],
    skills: ['Cyber warfare strategy', 'Network defense leadership', 'Policy development', 'Risk management', 'Interagency coordination'],
    industries: ['Cybersecurity', 'Defense Contracting', 'Financial Services', 'Technology', 'Federal Agencies'],
  },
  '3002': {
    civilianTitles: ['Supply Chain Director', 'Logistics Executive', 'Procurement Director', 'Operations Manager', 'Distribution Director'],
    skills: ['Supply chain leadership', 'Procurement management', 'Inventory oversight', 'Vendor management', 'Budget management'],
    industries: ['Logistics', 'Supply Chain', 'Defense Contracting', 'Manufacturing', 'Federal Agencies'],
  },
  '4402': {
    civilianTitles: ['Attorney', 'Corporate Counsel', 'Compliance Director', 'Legal Affairs Manager', 'Government Contracts Attorney'],
    skills: ['Military law', 'Contract law', 'Legal analysis', 'Compliance management', 'Negotiation'],
    industries: ['Legal', 'Defense Contracting', 'Corporate Counsel', 'Federal Agencies', 'Financial Services'],
  },
  '6002': {
    civilianTitles: ['Commercial Airline Pilot', 'Corporate Pilot', 'Aviation Program Manager', 'Flight Operations Director', 'Aviation Safety Manager'],
    skills: ['Fixed-wing aircraft operations', 'Instrument flight', 'Crew resource management', 'Aviation safety', 'Mission planning'],
    industries: ['Commercial Aviation', 'Corporate Aviation', 'Defense Contracting', 'Airlines', 'Aviation Safety'],
  },
  '6102': {
    civilianTitles: ['Commercial Helicopter Pilot', 'Corporate Aviation Director', 'Flight Operations Manager', 'Aviation Safety Inspector', 'EMS Pilot'],
    skills: ['Rotary wing operations', 'Crew resource management', 'Aviation safety', 'Mission planning', 'Emergency procedures'],
    industries: ['Commercial Aviation', 'Emergency Medical Services', 'Law Enforcement Aviation', 'Defense Contracting', 'Oil and Gas'],
  },

  // ══════════════════════════════════════════════════════════════════
  // NAVY — ENLISTED
  // ══════════════════════════════════════════════════════════════════

  'CTN': {
    civilianTitles: ['Cybersecurity Analyst', 'Network Security Engineer', 'SOC Analyst', 'Penetration Tester', 'Threat Intelligence Analyst'],
    skills: ['Network exploitation', 'Signals intelligence', 'Cyber defense', 'Digital forensics', 'Security monitoring'],
    industries: ['Cybersecurity', 'Defense Contracting', 'Federal Agencies', 'Financial Services', 'Technology'],
  },
  'CTI': {
    civilianTitles: ['Intelligence Linguist', 'Translator', 'Intelligence Analyst', 'Foreign Affairs Specialist', 'Research Analyst'],
    skills: ['Foreign language proficiency', 'SIGINT analysis', 'Translation', 'Cultural expertise', 'Intelligence reporting'],
    industries: ['Federal Agencies', 'Defense Contracting', 'International Organizations', 'Education', 'Consulting'],
  },
  'CWT': {
    civilianTitles: ['Cyber Warfare Analyst', 'Offensive Security Specialist', 'Red Team Operator', 'Penetration Tester', 'Threat Hunter'],
    skills: ['Offensive cyber operations', 'Vulnerability exploitation', 'Network analysis', 'Malware analysis', 'Threat modeling'],
    industries: ['Cybersecurity', 'Defense Contracting', 'Federal Agencies', 'Financial Services', 'Technology'],
  },
  'HM': {
    civilianTitles: ['Registered Nurse', 'Physician Assistant', 'EMT / Paramedic', 'Medical Assistant', 'Healthcare Administrator'],
    skills: ['Patient care', 'Emergency medicine', 'Medical procedures', 'Pharmacology basics', 'Medical documentation', 'Triage'],
    industries: ['Healthcare', 'Hospitals', 'Emergency Services', 'Veterans Services', 'Pharmaceuticals'],
  },
  'IS': {
    civilianTitles: ['Intelligence Analyst', 'Threat Analyst', 'Research Analyst', 'Risk Analyst', 'Policy Analyst'],
    skills: ['Intelligence analysis', 'OSINT', 'Data synthesis', 'Report writing', 'Geospatial analysis'],
    industries: ['Defense Contracting', 'Federal Agencies', 'Financial Services', 'Consulting', 'Technology'],
  },
  'IT': {
    civilianTitles: ['IT Systems Administrator', 'Network Engineer', 'Help Desk Manager', 'Cybersecurity Specialist', 'Cloud Engineer'],
    skills: ['Network administration', 'Systems management', 'Cybersecurity basics', 'Troubleshooting', 'Server maintenance'],
    industries: ['Information Technology', 'Telecommunications', 'Healthcare IT', 'Federal Agencies', 'Financial Services'],
  },
  'MA': {
    civilianTitles: ['Police Officer', 'Security Manager', 'Federal Law Enforcement Officer', 'Loss Prevention Manager', 'Corrections Officer'],
    skills: ['Law enforcement', 'Physical security', 'Investigations', 'Report writing', 'Crisis response'],
    industries: ['Law Enforcement', 'Private Security', 'Federal Agencies', 'Corrections', 'Corporate Security'],
  },
  'SO': {
    civilianTitles: ['Special Operations Consultant', 'Security Director', 'Federal Agent', 'Risk Consultant', 'Protective Services Specialist'],
    skills: ['Special operations', 'Close quarters combat', 'Mission planning', 'Leadership', 'Unconventional warfare'],
    industries: ['Defense Contracting', 'Federal Agencies', 'Private Security', 'Consulting', 'Intelligence'],
  },
  'BM': {
    civilianTitles: ['Maritime Operations Manager', 'Harbor Master', 'Port Operations Specialist', 'Vessel Captain', 'Maritime Safety Officer'],
    skills: ['Navigation', 'Seamanship', 'Small boat operations', 'Safety management', 'Team leadership'],
    industries: ['Maritime', 'Coast Guard', 'Port Operations', 'Commercial Shipping', 'Recreational Marine'],
  },

  // ══════════════════════════════════════════════════════════════════
  // NAVY — OFFICER
  // ══════════════════════════════════════════════════════════════════

  '1110': {
    civilianTitles: ['Maritime Operations Director', 'Port Authority Executive', 'Logistics Program Manager', 'Security Director', 'Operations VP'],
    skills: ['Ship command', 'Large-scale operations management', 'Personnel leadership (200–5000)', 'Budget management', 'Crisis decision-making', 'Joint operations'],
    industries: ['Maritime', 'Defense Contracting', 'Logistics', 'Federal Agencies', 'Corporate Leadership'],
  },
  '1120': {
    civilianTitles: ['Nuclear Operations Manager', 'Energy Program Director', 'Nuclear Engineer', 'Operations Executive', 'Submarine Systems Consultant'],
    skills: ['Nuclear propulsion systems', 'High-stakes operations', 'Personnel leadership', 'Safety protocols', 'Technical program management'],
    industries: ['Nuclear Energy', 'Defense Contracting', 'Federal Agencies', 'Engineering', 'Power Generation'],
  },
  '1130': {
    civilianTitles: ['Special Operations Director', 'Security Consultant', 'Federal Senior Agent', 'Crisis Management Executive', 'Risk Program Director'],
    skills: ['SEAL operations leadership', 'Strategic planning', 'Unconventional warfare', 'Interagency coordination', 'Personnel management'],
    industries: ['Defense Contracting', 'Federal Agencies', 'Private Security', 'Consulting', 'Intelligence'],
  },
  '1160': {
    civilianTitles: ['Aviation Program Manager', 'Weapons Systems Manager', 'Defense Contractor', 'Aviation Operations Director', 'Aerospace Systems Manager'],
    skills: ['Naval aviation systems', 'Weapons employment', 'Mission planning', 'Crew coordination', 'Program management'],
    industries: ['Defense Contracting', 'Aerospace', 'Aviation', 'Federal Agencies', 'Technology'],
  },
  '1170': {
    civilianTitles: ['Commercial Airline Pilot', 'Corporate Pilot', 'Aviation Safety Manager', 'Flight Operations Director', 'Aviation Program Manager'],
    skills: ['Fixed and rotary wing operations', 'Instrument flight', 'Crew resource management', 'Aviation safety', 'Mission planning'],
    industries: ['Commercial Aviation', 'Corporate Aviation', 'Airlines', 'Defense Contracting', 'Aviation Safety'],
  },
  '1310': {
    civilianTitles: ['Intelligence Director', 'Cryptology Program Manager', 'Signals Intelligence Executive', 'Cybersecurity Director', 'Information Operations Manager'],
    skills: ['Cryptologic operations', 'SIGINT program management', 'Intelligence analysis', 'Policy development', 'Interagency coordination'],
    industries: ['Defense Contracting', 'Federal Agencies', 'Cybersecurity', 'Technology', 'Consulting'],
  },
  '1320': {
    civilianTitles: ['Intelligence Director', 'Threat Analysis Executive', 'Risk Management Director', 'Research Director', 'Policy Advisor'],
    skills: ['Intelligence program management', 'All-source analysis', 'Executive briefing', 'Strategic assessment', 'Team leadership'],
    industries: ['Defense Contracting', 'Federal Agencies', 'Financial Services', 'Consulting', 'Technology'],
  },
  '1410': {
    civilianTitles: ['IT Director', 'Chief Information Officer (CIO)', 'Network Program Manager', 'Cybersecurity Executive', 'Digital Transformation Director'],
    skills: ['IT program management', 'Network architecture', 'Cybersecurity strategy', 'Budget management', 'Vendor management'],
    industries: ['Information Technology', 'Defense Contracting', 'Federal Agencies', 'Financial Services', 'Telecommunications'],
  },
  '1440': {
    civilianTitles: ['Cybersecurity Director', 'CISO', 'Cyber Operations Executive', 'Information Security Program Manager', 'Red Team Director'],
    skills: ['Cyber warfare operations', 'Defensive cyber strategy', 'Policy development', 'Risk management', 'Interagency coordination'],
    industries: ['Cybersecurity', 'Defense Contracting', 'Financial Services', 'Technology', 'Federal Agencies'],
  },
  '2100': {
    civilianTitles: ['Supply Chain Director', 'Logistics Executive', 'Procurement Director', 'Operations VP', 'Distribution Director'],
    skills: ['Supply chain strategy', 'Procurement management', 'Logistics oversight', 'Budget management', 'Vendor management'],
    industries: ['Logistics', 'Supply Chain', 'Defense Contracting', 'Manufacturing', 'Retail'],
  },
  '2200': {
    civilianTitles: ['Physician', 'Medical Director', 'Healthcare Executive', 'Clinical Program Director', 'Aerospace Medicine Specialist'],
    skills: ['Medical leadership', 'Clinical operations management', 'Healthcare program management', 'Patient care', 'Policy development'],
    industries: ['Healthcare', 'Hospitals', 'Defense Contracting', 'Federal Agencies', 'Insurance'],
  },
  '2500': {
    civilianTitles: ['Director of Nursing', 'Nurse Practitioner', 'Clinical Nurse Specialist', 'Healthcare Administrator', 'Flight Nurse'],
    skills: ['Nursing leadership', 'Clinical care', 'Healthcare operations', 'Patient advocacy', 'Team management'],
    industries: ['Healthcare', 'Hospitals', 'Federal Agencies', 'Defense Contracting', 'Veterans Services'],
  },
  '3200': {
    civilianTitles: ['Attorney', 'Corporate Counsel', 'Compliance Director', 'Government Contracts Attorney', 'Legal Affairs Executive'],
    skills: ['Military law', 'Contract law', 'Legal analysis', 'Compliance management', 'Negotiation', 'Litigation'],
    industries: ['Legal', 'Defense Contracting', 'Corporate Counsel', 'Federal Agencies', 'Financial Services'],
  },
  '3100': {
    civilianTitles: ['Civil Engineer', 'Construction Program Director', 'Infrastructure Executive', 'Facilities Management Director', 'Project Controls Manager'],
    skills: ['Civil engineering', 'Construction management', 'Contract oversight', 'Budget management', 'Safety leadership'],
    industries: ['Construction', 'Engineering', 'Infrastructure', 'Defense Contracting', 'Federal Agencies'],
  },

  // ══════════════════════════════════════════════════════════════════
  // AIR FORCE — ENLISTED
  // ══════════════════════════════════════════════════════════════════

  '1B4X1': {
    civilianTitles: ['Cybersecurity Analyst', 'Penetration Tester', 'SOC Analyst', 'Threat Intelligence Analyst', 'Information Systems Security Officer (ISSO)'],
    skills: ['Offensive cyber operations', 'Network exploitation', 'Vulnerability assessment', 'Digital forensics', 'SIEM tools', 'Incident response'],
    industries: ['Cybersecurity', 'Defense Contracting', 'Federal Agencies', 'Financial Services', 'Technology'],
  },
  '1C1X1': {
    civilianTitles: ['Air Traffic Controller (FAA)', 'Aviation Operations Manager', 'Airport Operations Specialist', 'Flight Dispatcher', 'Aviation Safety Inspector'],
    skills: ['Air traffic management', 'Radar systems', 'Radio communications', 'Safety protocols', 'Emergency response'],
    industries: ['Aviation', 'Airlines', 'Airport Operations', 'FAA', 'Defense Contracting'],
  },
  '1C2X1': {
    civilianTitles: ['Special Operations Consultant', 'Emergency Management Director', 'Aviation Safety Specialist', 'Federal Agent', 'Search and Rescue Coordinator'],
    skills: ['Combat control', 'Air traffic management in combat', 'Special operations', 'Crisis leadership', 'Joint terminal attack control'],
    industries: ['Defense Contracting', 'Federal Agencies', 'Emergency Management', 'Aviation', 'Law Enforcement'],
  },
  '1C4X1': {
    civilianTitles: ['Joint Terminal Attack Controller (Contractor)', 'Air Operations Coordinator', 'Defense Contractor', 'Special Operations Advisor', 'Aviation Liaison'],
    skills: ['Close air support', 'Joint operations', 'Radio communications', 'Target acquisition', 'Mission planning'],
    industries: ['Defense Contracting', 'Federal Agencies', 'Aviation', 'Consulting', 'Security'],
  },
  '1N0X1': {
    civilianTitles: ['Intelligence Analyst', 'All-Source Analyst', 'Risk Analyst', 'Threat Intelligence Analyst', 'Research Analyst'],
    skills: ['All-source intelligence analysis', 'Intelligence production', 'Targeting', 'Geospatial analysis', 'Report writing'],
    industries: ['Defense Contracting', 'Federal Agencies', 'Financial Services', 'Consulting', 'Technology'],
  },
  '1N1X1': {
    civilianTitles: ['Geospatial Analyst', 'GIS Specialist', 'Remote Sensing Analyst', 'Imagery Analyst', 'Mapping Specialist'],
    skills: ['Geospatial intelligence', 'Imagery analysis', 'GIS tools', 'Remote sensing', 'Cartography'],
    industries: ['Defense Contracting', 'Federal Agencies', 'Technology', 'Environmental Services', 'Urban Planning'],
  },
  '1N2X1': {
    civilianTitles: ['Signals Intelligence Analyst', 'RF Engineer', 'Electronic Warfare Analyst', 'Communications Security Specialist', 'Cybersecurity Analyst'],
    skills: ['Signals collection', 'Spectrum analysis', 'Electronic intelligence', 'Communications systems', 'Technical reporting'],
    industries: ['Defense Contracting', 'Federal Agencies', 'Telecommunications', 'Cybersecurity', 'Technology'],
  },
  '1N3X1': {
    civilianTitles: ['Intelligence Linguist', 'Translator', 'Cryptologic Analyst', 'Foreign Affairs Specialist', 'Research Analyst'],
    skills: ['Foreign language proficiency', 'Cryptologic analysis', 'Translation', 'Cultural expertise', 'Intelligence reporting'],
    industries: ['Federal Agencies', 'Defense Contracting', 'International Organizations', 'Education', 'Consulting'],
  },
  '1T2X1': {
    civilianTitles: ['Pararescue Contractor', 'Emergency Medical Technician (EMT)', 'Search and Rescue Specialist', 'Paramedic', 'Wilderness Medicine Specialist'],
    skills: ['Combat rescue', 'Advanced trauma care', 'Parachuting', 'SCUBA diving', 'Emergency medicine'],
    industries: ['Healthcare', 'Emergency Services', 'Defense Contracting', 'Aviation', 'Fire Departments'],
  },
  '1U0X1': {
    civilianTitles: ['UAS/Drone Operator', 'Remotely Piloted Aircraft Contractor', 'Drone Technology Specialist', 'Aviation Systems Operator', 'Defense Contractor'],
    skills: ['Remotely piloted aircraft systems', 'Sensor operation', 'ISR mission execution', 'Situational awareness', 'Multi-crew coordination'],
    industries: ['Defense Contracting', 'Agriculture', 'Film and Media', 'Public Safety', 'Infrastructure Inspection'],
  },
  '1W0X1': {
    civilianTitles: ['Meteorologist', 'Weather Forecaster', 'Atmospheric Scientist', 'Environmental Consultant', 'Emergency Management Specialist'],
    skills: ['Meteorological analysis', 'Weather forecasting', 'Environmental data interpretation', 'Report writing', 'Emergency weather response'],
    industries: ['Government', 'Airlines', 'Agriculture', 'Emergency Management', 'Environmental Services'],
  },
  '2A6X1': {
    civilianTitles: ['Aircraft Engine Mechanic', 'Aerospace Propulsion Technician', 'Aviation Maintenance Technician', 'FAA Powerplant Mechanic', 'Turbine Engine Specialist'],
    skills: ['Jet engine maintenance', 'Propulsion systems', 'Safety inspections', 'Technical documentation', 'Troubleshooting'],
    industries: ['Aviation', 'Airlines', 'Aerospace', 'Defense Contracting', 'MRO (Maintenance, Repair, Overhaul)'],
  },
  '2F0X1': {
    civilianTitles: ['Petroleum Supply Technician', 'Fuel Operations Manager', 'Pipeline Safety Inspector', 'Logistics Coordinator', 'Aviation Fueling Specialist'],
    skills: ['Fuel systems management', 'Safety compliance', 'Inventory control', 'Equipment operation', 'Regulatory compliance'],
    industries: ['Aviation', 'Oil and Gas', 'Transportation', 'Federal Agencies', 'Logistics'],
  },
  '2S0X1': {
    civilianTitles: ['Supply Chain Manager', 'Logistics Coordinator', 'Inventory Control Specialist', 'Procurement Manager', 'Warehouse Manager'],
    skills: ['Supply chain management', 'Inventory control', 'ERP systems', 'Procurement', 'Logistics planning'],
    industries: ['Logistics', 'Manufacturing', 'Retail', 'Healthcare', 'Federal Agencies'],
  },
  '2T1X1': {
    civilianTitles: ['Fleet Manager', 'Transportation Coordinator', 'Logistics Manager', 'CDL Driver', 'Motor Pool Supervisor'],
    skills: ['Fleet management', 'Vehicle operations', 'Route planning', 'Safety compliance', 'Logistics coordination'],
    industries: ['Transportation', 'Logistics', 'Construction', 'Federal Agencies', 'Corporate Fleet Services'],
  },
  '2W0X1': {
    civilianTitles: ['Munitions Technician', 'EOD Specialist', 'Explosives Safety Officer', 'Defense Contractor', 'Hazmat Specialist'],
    skills: ['Munitions handling', 'Explosives safety', 'Inventory management', 'Quality control', 'Technical documentation'],
    industries: ['Defense Contracting', 'Mining', 'Law Enforcement', 'Federal Agencies', 'Construction'],
  },
  '3D0X2': {
    civilianTitles: ['Cybersecurity Analyst', 'Systems Administrator', 'Network Engineer', 'SOC Analyst', 'Cloud Security Specialist'],
    skills: ['Cyber systems operations', 'Network defense', 'Systems administration', 'Security monitoring', 'Vulnerability management'],
    industries: ['Cybersecurity', 'Information Technology', 'Defense Contracting', 'Federal Agencies', 'Financial Services'],
  },
  '3D0X3': {
    civilianTitles: ['Information Systems Security Officer (ISSO)', 'Cybersecurity Manager', 'Compliance Analyst', 'Security Architect', 'Risk Manager'],
    skills: ['Cybersecurity policy', 'Risk management framework (RMF)', 'Security auditing', 'Compliance management', 'Vulnerability assessment'],
    industries: ['Cybersecurity', 'Defense Contracting', 'Federal Agencies', 'Financial Services', 'Healthcare IT'],
  },
  '3D1X1': {
    civilianTitles: ['IT Support Specialist', 'Systems Administrator', 'Help Desk Technician', 'Desktop Support Engineer', 'IT Manager'],
    skills: ['Client systems support', 'Hardware troubleshooting', 'Software installation', 'Network basics', 'User support'],
    industries: ['Information Technology', 'Healthcare IT', 'Education', 'Corporate', 'Federal Agencies'],
  },
  '3D1X2': {
    civilianTitles: ['Network Engineer', 'Telecommunications Specialist', 'Network Administrator', 'Systems Engineer', 'Infrastructure Engineer'],
    skills: ['Network infrastructure', 'Routing and switching', 'Fiber optics', 'Telecommunications systems', 'Network security'],
    industries: ['Telecommunications', 'Information Technology', 'Defense Contracting', 'Federal Agencies', 'Healthcare IT'],
  },
  '3E7X1': {
    civilianTitles: ['Fire Captain', 'Fire Inspector', 'Firefighter', 'Emergency Management Coordinator', 'Fire Safety Consultant'],
    skills: ['Firefighting', 'Aircraft rescue', 'Hazmat response', 'Emergency medical response', 'Safety inspections'],
    industries: ['Fire Departments', 'Aviation', 'Emergency Services', 'Industrial Safety', 'Federal Agencies'],
  },
  '3E8X1': {
    civilianTitles: ['EOD Technician', 'Bomb Squad Officer', 'Explosives Safety Specialist', 'Hazmat Technician', 'Federal Agent'],
    skills: ['Explosive ordnance disposal', 'Hazardous materials handling', 'Robot operations', 'Risk assessment', 'Technical reporting'],
    industries: ['Law Enforcement', 'Federal Agencies', 'Defense Contracting', 'Aviation Security', 'Mining'],
  },
  '3F0X1': {
    civilianTitles: ['Human Resources Manager', 'Talent Acquisition Specialist', 'HR Business Partner', 'Benefits Specialist', 'People Operations Manager'],
    skills: ['Personnel management', 'Talent acquisition', 'Benefits administration', 'Employee relations', 'HR compliance'],
    industries: ['Human Resources', 'Corporate', 'Healthcare', 'Federal Agencies', 'Education'],
  },
  '3N0X1': {
    civilianTitles: ['Public Affairs Specialist', 'Communications Director', 'Media Relations Manager', 'Content Strategist', 'Marketing Manager'],
    skills: ['Strategic communications', 'Media relations', 'Content creation', 'Crisis communications', 'Social media management'],
    industries: ['Public Relations', 'Marketing', 'Federal Agencies', 'Nonprofit', 'Corporate Communications'],
  },
  '3P0X1': {
    civilianTitles: ['Police Officer', 'Security Manager', 'Federal Law Enforcement Officer', 'Loss Prevention Director', 'Corporate Security Manager'],
    skills: ['Law enforcement', 'Physical security', 'Investigations', 'Anti-terrorism', 'Emergency response'],
    industries: ['Law Enforcement', 'Private Security', 'Federal Agencies', 'Aviation Security', 'Corporate Security'],
  },
  '4N0X1': {
    civilianTitles: ['Flight Medic', 'Aerospace Medical Technician', 'EMT', 'Paramedic', 'Healthcare Administrator'],
    skills: ['Aerospace medicine', 'Emergency medical care', 'Patient assessment', 'Flight physiology', 'Medical documentation'],
    industries: ['Healthcare', 'Aviation Medicine', 'Emergency Services', 'Defense Contracting', 'Hospitals'],
  },
  '6C0X1': {
    civilianTitles: ['Procurement Specialist', 'Contract Manager', 'Acquisitions Manager', 'Supply Chain Analyst', 'Vendor Relations Manager'],
    skills: ['Federal contracting', 'FAR/DFARS compliance', 'Procurement', 'Contract negotiation', 'Vendor management'],
    industries: ['Defense Contracting', 'Federal Agencies', 'Corporate Procurement', 'Healthcare', 'Technology'],
  },
  '6F0X1': {
    civilianTitles: ['Financial Analyst', 'Budget Analyst', 'Accountant', 'Financial Manager', 'Controller'],
    skills: ['Financial management', 'Budget analysis', 'Accounting', 'Financial reporting', 'Compliance'],
    industries: ['Finance', 'Federal Agencies', 'Defense Contracting', 'Corporate Finance', 'Accounting Firms'],
  },
  '7S0X1': {
    civilianTitles: ['Special Agent', 'Criminal Investigator', 'Corporate Investigator', 'Fraud Analyst', 'Federal Law Enforcement Officer'],
    skills: ['Criminal investigations', 'Surveillance', 'Interviewing', 'Evidence collection', 'Report writing'],
    industries: ['Federal Law Enforcement', 'Corporate Security', 'Insurance', 'Financial Services', 'Legal'],
  },
  '8R000': {
    civilianTitles: ['Talent Acquisition Specialist', 'Corporate Recruiter', 'HR Business Partner', 'Sales Representative', 'Account Manager'],
    skills: ['Recruiting', 'Sales', 'Relationship building', 'Presentations', 'Goal achievement'],
    industries: ['Human Resources', 'Sales', 'Staffing', 'Corporate', 'Real Estate'],
  },

  // ══════════════════════════════════════════════════════════════════
  // AIR FORCE — OFFICER
  // ══════════════════════════════════════════════════════════════════

  '11X': {
    civilianTitles: ['Commercial Airline Pilot', 'Corporate Pilot', 'Aviation Safety Manager', 'Flight Operations Director', 'Aviation Program Manager'],
    skills: ['Multi-engine aircraft operations', 'Instrument flight rules (IFR)', 'Crew resource management', 'Aviation safety', 'High-stakes decision-making'],
    industries: ['Commercial Aviation', 'Corporate Aviation', 'Airlines', 'Defense Contracting', 'Aviation Safety'],
  },
  '11B-PILOT': {
    civilianTitles: ['B-52 / B-1 Contractor Pilot', 'Aviation Systems Program Manager', 'Defense Contractor', 'Aviation Safety Manager', 'Flight Operations Director'],
    skills: ['Strategic bomber operations', 'Long-range mission planning', 'Weapons systems employment', 'Crew leadership', 'Aviation safety'],
    industries: ['Defense Contracting', 'Aviation', 'Aerospace', 'Federal Agencies', 'Corporate Aviation'],
  },
  '11F': {
    civilianTitles: ['Commercial Airline Pilot', 'Corporate Pilot', 'Aviation Safety Inspector', 'Test Pilot', 'Flight Operations Manager'],
    skills: ['Fighter aircraft operations', 'High-performance flight', 'Weapons employment', 'Instrument flight', 'Crew resource management'],
    industries: ['Commercial Aviation', 'Airlines', 'Defense Contracting', 'Aerospace', 'Aviation Safety'],
  },
  '11S': {
    civilianTitles: ['Special Operations Aviation Contractor', 'Aviation Program Manager', 'Flight Operations Director', 'Corporate Pilot', 'Defense Contractor'],
    skills: ['Special operations aviation', 'Low-level flight operations', 'Night vision operations', 'Mission planning', 'Crew leadership'],
    industries: ['Defense Contracting', 'Corporate Aviation', 'Federal Agencies', 'Aviation', 'Consulting'],
  },
  '11U': {
    civilianTitles: ['UAS Program Manager', 'Drone Operations Director', 'RPA Systems Specialist', 'Aviation Safety Manager', 'Defense Contractor'],
    skills: ['Remotely piloted aircraft command', 'ISR mission planning', 'Multi-crew operations', 'Sensor management', 'Aviation safety'],
    industries: ['Defense Contracting', 'Technology', 'Agriculture', 'Public Safety', 'Infrastructure'],
  },
  '12X': {
    civilianTitles: ['Weapons Systems Program Manager', 'Aviation Operations Director', 'Defense Contractor', 'Aerospace Systems Manager', 'Mission Planning Director'],
    skills: ['Combat systems operations', 'Weapons employment', 'Mission planning', 'Crew coordination', 'Electronic warfare'],
    industries: ['Defense Contracting', 'Aerospace', 'Aviation', 'Federal Agencies', 'Technology'],
  },
  '13B': {
    civilianTitles: ['Air Traffic Management Director', 'Aviation Operations Manager', 'Aerospace Program Manager', 'Defense Contractor', 'FAA Operations Manager'],
    skills: ['Airspace management', 'Battle management', 'Air operations coordination', 'Radar systems', 'Joint operations'],
    industries: ['Aviation', 'Defense Contracting', 'Federal Agencies', 'FAA', 'Aerospace'],
  },
  '13S': {
    civilianTitles: ['Space Systems Program Manager', 'Satellite Operations Director', 'Aerospace Engineer', 'Space Policy Advisor', 'Defense Contractor'],
    skills: ['Space operations', 'Satellite systems', 'Orbital mechanics', 'Mission planning', 'Program management'],
    industries: ['Aerospace', 'Defense Contracting', 'Technology', 'Federal Agencies', 'Commercial Space'],
  },
  '14N': {
    civilianTitles: ['Intelligence Director', 'Threat Intelligence Executive', 'Risk Program Manager', 'Research Director', 'Senior Intelligence Advisor'],
    skills: ['Intelligence program management', 'All-source analysis', 'Executive briefing', 'Policy development', 'Interagency coordination'],
    industries: ['Defense Contracting', 'Federal Agencies', 'Financial Services', 'Consulting', 'Technology'],
  },
  '17D': {
    civilianTitles: ['CISO', 'Cyber Operations Director', 'VP of Cybersecurity', 'Information Security Program Manager', 'Red Team Director'],
    skills: ['Cyber warfare strategy', 'Defensive cyber operations', 'Policy development', 'Risk management', 'Budget management', 'Team leadership'],
    industries: ['Cybersecurity', 'Defense Contracting', 'Financial Services', 'Technology', 'Federal Agencies'],
  },
  '17S': {
    civilianTitles: ['Cybersecurity Executive', 'IT Security Director', 'Cyber Program Manager', 'Information Assurance Director', 'Digital Transformation Leader'],
    skills: ['Cyberspace operations strategy', 'Information systems security', 'Policy development', 'Risk management', 'Interagency coordination'],
    industries: ['Cybersecurity', 'Defense Contracting', 'Technology', 'Federal Agencies', 'Financial Services'],
  },
  '21A': {
    civilianTitles: ['Aviation Maintenance Director', 'MRO Operations Executive', 'Aerospace Program Manager', 'Fleet Maintenance Director', 'Aviation Safety Director'],
    skills: ['Aircraft maintenance program management', 'Safety oversight', 'Budget management', 'Vendor management', 'Quality assurance leadership'],
    industries: ['Aviation', 'Airlines', 'Aerospace', 'Defense Contracting', 'MRO'],
  },
  '21R': {
    civilianTitles: ['Supply Chain Director', 'Logistics Executive', 'Operations VP', 'Procurement Director', 'Distribution Center Director'],
    skills: ['Logistics strategy', 'Supply chain management', 'Procurement oversight', 'Budget management', 'Vendor management'],
    industries: ['Logistics', 'Supply Chain', 'Defense Contracting', 'Manufacturing', 'Retail'],
  },
  '25A-OFFICER': {
    civilianTitles: ['Chief Information Officer (CIO)', 'IT Director', 'Communications Program Director', 'Network Engineering Executive', 'Digital Transformation Leader'],
    skills: ['IT strategy', 'Communications systems leadership', 'Cybersecurity oversight', 'Budget management', 'Vendor management'],
    industries: ['Information Technology', 'Telecommunications', 'Defense Contracting', 'Federal Agencies', 'Financial Services'],
  },
  '31P': {
    civilianTitles: ['Police Chief', 'Security Director', 'Federal Law Enforcement Executive', 'Corporate Security VP', 'Risk Management Director'],
    skills: ['Security forces leadership', 'Law enforcement program management', 'Anti-terrorism', 'Policy development', 'Emergency management'],
    industries: ['Law Enforcement', 'Corporate Security', 'Federal Agencies', 'Aviation Security', 'Private Security'],
  },
  '32E': {
    civilianTitles: ['Civil Engineer', 'Construction Program Director', 'Infrastructure Executive', 'Facilities Management Director', 'Project Controls Manager'],
    skills: ['Civil engineering', 'Construction management', 'Contract oversight', 'Budget management', 'Environmental compliance'],
    industries: ['Construction', 'Engineering', 'Infrastructure', 'Defense Contracting', 'Federal Agencies'],
  },
  '34P': {
    civilianTitles: ['Chief Human Resources Officer (CHRO)', 'HR Director', 'Talent Management Executive', 'People Operations VP', 'Organizational Development Director'],
    skills: ['HR strategy', 'Talent acquisition', 'Organizational development', 'Policy development', 'Employee relations'],
    industries: ['Human Resources', 'Corporate', 'Healthcare', 'Federal Agencies', 'Consulting'],
  },
  '35P-OFFICER': {
    civilianTitles: ['Communications Director', 'Public Affairs Executive', 'Media Relations Director', 'Brand Strategy Director', 'Corporate Communications VP'],
    skills: ['Strategic communications', 'Crisis communications', 'Media relations', 'Content strategy', 'Executive communications'],
    industries: ['Public Relations', 'Marketing', 'Corporate Communications', 'Federal Agencies', 'Consulting'],
  },
  '40C': {
    civilianTitles: ['Chaplain', 'Counselor', 'Nonprofit Director', 'Organizational Wellness Director', 'Employee Assistance Program Manager'],
    skills: ['Pastoral counseling', 'Crisis intervention', 'Spiritual care', 'Organizational wellness', 'Community outreach'],
    industries: ['Nonprofit', 'Healthcare', 'Education', 'Veterans Services', 'Corporate Wellness'],
  },
  '41A': {
    civilianTitles: ['Healthcare Administrator', 'Hospital Operations Director', 'Medical Program Manager', 'Health Services Executive', 'Practice Manager'],
    skills: ['Healthcare administration', 'Medical program management', 'Budget oversight', 'Policy development', 'Team leadership'],
    industries: ['Healthcare', 'Hospitals', 'Defense Contracting', 'Federal Agencies', 'Insurance'],
  },
  '43A': {
    civilianTitles: ['Aerospace Medicine Physician', 'Occupational Medicine Physician', 'Medical Director', 'Flight Surgeon', 'Healthcare Executive'],
    skills: ['Aerospace medicine', 'Occupational health', 'Medical program management', 'Regulatory compliance', 'Clinical leadership'],
    industries: ['Healthcare', 'Aviation Medicine', 'Defense Contracting', 'Federal Agencies', 'Insurance'],
  },
  '44F': {
    civilianTitles: ['Family Physician', 'Primary Care Director', 'Medical Director', 'Healthcare Executive', 'Clinical Program Manager'],
    skills: ['Primary care medicine', 'Preventive medicine', 'Clinical leadership', 'Healthcare administration', 'Patient care'],
    industries: ['Healthcare', 'Hospitals', 'Federal Agencies', 'Defense Contracting', 'Insurance'],
  },
  '51J': {
    civilianTitles: ['Attorney', 'Corporate Counsel', 'Compliance Director', 'Government Contracts Attorney', 'Legal Affairs Executive'],
    skills: ['Military law', 'Contract law', 'Legal analysis', 'Compliance management', 'Negotiation', 'Litigation'],
    industries: ['Legal', 'Defense Contracting', 'Corporate Counsel', 'Federal Agencies', 'Financial Services'],
  },
  '52R': {
    civilianTitles: ['Aerospace Engineer', 'Systems Engineer', 'R&D Program Manager', 'Defense Systems Architect', 'Technology Director'],
    skills: ['Systems engineering', 'R&D program management', 'Technical analysis', 'Budget management', 'Vendor management'],
    industries: ['Aerospace', 'Defense Contracting', 'Technology', 'Federal Agencies', 'Engineering'],
  },
  '60C': {
    civilianTitles: ['Procurement Director', 'Contracts Executive', 'Acquisitions Director', 'Supply Chain VP', 'Vendor Management Director'],
    skills: ['Federal contracting', 'FAR/DFARS compliance', 'Contract management', 'Procurement strategy', 'Negotiation'],
    industries: ['Defense Contracting', 'Federal Agencies', 'Corporate Procurement', 'Technology', 'Healthcare'],
  },
  '61C': {
    civilianTitles: ['Financial Director', 'Controller', 'CFO', 'Budget Director', 'Financial Program Manager'],
    skills: ['Financial management', 'Budget oversight', 'Accounting systems', 'Audit compliance', 'Financial reporting'],
    industries: ['Finance', 'Federal Agencies', 'Defense Contracting', 'Corporate Finance', 'Consulting'],
  },

  // ══════════════════════════════════════════════════════════════════
  // SPACE FORCE — OFFICER
  // ══════════════════════════════════════════════════════════════════

  '13SA': {
    civilianTitles: ['Space Systems Program Manager', 'Orbital Operations Director', 'Satellite Warfare Analyst', 'Aerospace Systems Manager', 'Defense Contractor'],
    skills: ['Orbital warfare operations', 'Space domain awareness', 'Satellite systems', 'Mission planning', 'Program management'],
    industries: ['Aerospace', 'Defense Contracting', 'Technology', 'Commercial Space', 'Federal Agencies'],
  },
  '13SH': {
    civilianTitles: ['Satellite Communications Director', 'Telecommunications Program Manager', 'Space Systems Engineer', 'SATCOM Architect', 'Defense Contractor'],
    skills: ['Satellite communications', 'SATCOM systems', 'Network architecture', 'Program management', 'Systems integration'],
    industries: ['Telecommunications', 'Aerospace', 'Defense Contracting', 'Technology', 'Federal Agencies'],
  },

  // ══════════════════════════════════════════════════════════════════
  // COAST GUARD — ENLISTED
  // ══════════════════════════════════════════════════════════════════

  'ME': {
    civilianTitles: ['Federal Law Enforcement Officer', 'Border Patrol Agent', 'Police Officer', 'Security Manager', 'Maritime Law Enforcement Officer'],
    skills: ['Maritime law enforcement', 'Boarding operations', 'Drug interdiction', 'Search and rescue', 'Law enforcement procedures'],
    industries: ['Federal Law Enforcement', 'Maritime', 'Port Security', 'Private Security', 'Law Enforcement'],
  },
  'MST': {
    civilianTitles: ['Environmental Compliance Officer', 'Safety Inspector', 'Port Safety Specialist', 'Hazmat Specialist', 'Environmental Consultant'],
    skills: ['Marine safety inspections', 'Environmental compliance', 'Hazmat response', 'Port safety', 'Regulatory compliance'],
    industries: ['Environmental Services', 'Maritime', 'Federal Agencies', 'Oil and Gas', 'Port Operations'],
  },
  'AST': {
    civilianTitles: ['Search and Rescue Specialist', 'Rescue Swimmer Contractor', 'Paramedic', 'EMT', 'Emergency Management Specialist'],
    skills: ['Aviation rescue swimming', 'Emergency medicine', 'Helicopter operations', 'Survival techniques', 'Trauma care'],
    industries: ['Emergency Services', 'Aviation', 'Healthcare', 'Defense Contracting', 'Fire Departments'],
  },

  // ══════════════════════════════════════════════════════════════════
  // COAST GUARD — OFFICER
  // ══════════════════════════════════════════════════════════════════

  'OPS': {
    civilianTitles: ['Maritime Operations Director', 'Port Authority Executive', 'Emergency Management Director', 'Logistics Program Manager', 'Security Director'],
    skills: ['Maritime operations leadership', 'Emergency management', 'Personnel management', 'Budget oversight', 'Interagency coordination'],
    industries: ['Maritime', 'Port Operations', 'Emergency Management', 'Federal Agencies', 'Logistics'],
  },
  'RESP': {
    civilianTitles: ['Emergency Management Director', 'Search and Rescue Program Manager', 'Crisis Response Director', 'Public Safety Executive', 'Disaster Response Coordinator'],
    skills: ['Search and rescue leadership', 'Crisis management', 'Interagency coordination', 'Emergency response planning', 'Personnel management'],
    industries: ['Emergency Management', 'Federal Agencies', 'Nonprofit', 'Public Safety', 'Healthcare'],
  },
  'AVI': {
    civilianTitles: ['Commercial Helicopter Pilot', 'Aviation Safety Manager', 'Flight Operations Director', 'EMS Pilot', 'Coast Guard Aviation Contractor'],
    skills: ['Rotary wing operations', 'Search and rescue aviation', 'Crew resource management', 'Aviation safety', 'Mission planning'],
    industries: ['Commercial Aviation', 'Emergency Medical Services', 'Law Enforcement Aviation', 'Defense Contracting', 'Maritime'],
  },
  'JAG': {
    civilianTitles: ['Attorney', 'Maritime Law Specialist', 'Corporate Counsel', 'Compliance Director', 'Government Contracts Attorney'],
    skills: ['Maritime law', 'Environmental law', 'Contract law', 'Compliance management', 'Legal analysis'],
    industries: ['Legal', 'Maritime', 'Environmental Services', 'Corporate Counsel', 'Federal Agencies'],
  },
};

// Fallback for codes not yet in the translation layer
export const fallbackTranslation = {
  civilianTitles: [],
  skills: [],
  industries: [],
  noData: true,
};

export function getTranslation(code) {
  return translations[code] || fallbackTranslation;
}